import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { UserService } from './user.service';
import { Member } from './../../common/models/member';
import { environment } from '../../../environments/environment';
import { User } from './../../common/models/user';
import { promotions } from './../../common/config/promotions';
import { SessionManager } from '../../common/helpers/session-manager';

import * as _ from 'lodash';

@Injectable()
export class AuthenticationService {
    public token: string;
    private emblanoUrl = environment.emblanoUrl;
    private host = environment.host;
    user = new User();
    isLoginSubject = new BehaviorSubject<boolean>(this.hasUser());

    constructor(private http: Http, private sessionManager: SessionManager) {
        const currentUser = this.sessionManager.getCurrentUser();
        this.token = currentUser && currentUser.token;
    }

    login(email: string, password: string): Observable<User> {

        const loginModel = JSON.stringify({ Email: email, Password: password });
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(this.emblanoUrl + '/api/authentication/login', { Email: email, Password: password }, options)
            .map((response: Response) => {

                this.user.firstName = response.json().FirstName;
                this.user.lastName = response.json().LastName;
                this.user.email = response.json().Email;
                this.user.id = response.json().id;

                if (this.user) {
                    localStorage.setItem('currentUser', JSON.stringify(this.user));
                    this.isLoginSubject.next(true);
                    return this.user;
                } else {
                    return null;
                }
            });
    }

    getCurrentUser(): Observable<any> {

        const usr = this.sessionManager.getCurrentUser();
        const member = new Member();

        if (usr != null) {
            const id = usr.id;

            return this.http.get(this.host + '/api/account/getCustomerDetails?customerId=' + id, JSON.stringify({}))
                .map((response: Response) => {
                    if (id == null || id === undefined) {
                        return member;
                    } else {
                        member.firstName = response.json().firstName;
                        member.middleName = response.json().middleName;
                        member.lastName = response.json().lastName;
                        member.emailAddress = response.json().emailAddress;
                        member.password = response.json().password;
                        member.confirmPassword = response.json().password;
                        member.city = response.json().city;
                        member.postalCode = response.json().postalCode;
                        member.country = response.json().country;
                        member.street1 = response.json().street1;
                        member.street2 = response.json().street2;
                        member.purchasedProducts = response.json().purchasedProducts;
                        return member;
                    }
                });
        } else {
            return Observable.of(member);
        }
    }

    removeCurrentUser() {
        this.token = null;
        this.sessionManager.removeCurrentUser();
        this.isLoginSubject.next(false);
    }


    logout(): any {
        // clear token remove user from local storage to log user out
        const registerUrl = this.emblanoUrl + '/api/authentication/logoff';
        const email = this.sessionManager.getCurrentUser().email;
        const url = registerUrl + '?' + 'email' + '=' + email;

        return this.http.get(url);
    }


    getCustomerDetails(customerId: string): any {

        return this.http.get(this.host + '/api/account/getCustomerDetails?customerId=' + customerId, JSON.stringify({}))
            .map((response: Response) => {

                this.user.firstName = response.json().firstName;
                this.user.lastName = response.json().lastName;
                this.user.email = response.json().emailAddress;
                this.user.id = response.json().customerId;

                if (this.user) {
                    this.sessionManager.setCurrentUser(this.user);
                    return this.user;
                } else {
                    return null;
                }
            });
    }

    isLoggedIn(): Observable<boolean> {
        return this.isLoginSubject.asObservable();
    }


    private hasUser(): boolean {
        return !!this.sessionManager.getCurrentUser();
    }

    CheckAlreadyPaidUser(purchasedProducts: string): Observable<any> {
        if (purchasedProducts != null) {

            const purchaseProductsArray = purchasedProducts.split(';');
            if (purchaseProductsArray.includes('OEMBLAV10')) {
                return Observable.of(true);
            } else {
                return Observable.of(false);
            }
        }
        return Observable.of(false);
    }

    CheckAlreadyExistActiveMember(emailAddress : string) : Observable<any> {
        return this.http.get(this.host + '/api/account/checkEmailExist?emailAddress=' + emailAddress)
        .map((response: Response) => {
           return response;
        });
    }


    CheckAlreadyPaidUserForExistingEmail(email: string): Observable<any> {
        return this.http.get(this.host + '/api/account/isCustomerPurchasedProductExist?email=' + email
         + '&sessionId=' + localStorage.getItem('sessionID'), JSON.stringify({}))
        .map((response: Response) => {
            return response.json();
        });
    }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/services/authentication.service.ts